// extracted by mini-css-extract-plugin
export default {"button":"Utilities_button__EML0O","btn":"Utilities_btn__7F9F3","MuiDrawer-modal":"Utilities_MuiDrawer-modal__csgEv","tb-user-star":"Utilities_tb-user-star__boUx5"};